export default __webpack_public_path__ + "static/media/family_avatar_3.77f44de1.svg";